import React, { useEffect, useState } from "react";
import Logo from "./Logo";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goto = (id) => {
    setMobileOpen(false);
    setTimeout(() => scrollTo(id), 60);
  };

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-[#F5F0E8]/95 backdrop-blur-sm border-b border-[#E5DFD3]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Logo size="md" onClick={() => goto("top")} />

        <nav className="hidden md:flex items-center gap-10 text-sm text-[#1A1A1A]">
          <button
            data-testid="nav-features-link"
            onClick={() => goto("features")}
            className="hover:text-[#3D7A5A] transition-colors"
          >
            Features
          </button>
          <button
            data-testid="nav-how-link"
            onClick={() => goto("how")}
            className="hover:text-[#3D7A5A] transition-colors"
          >
            How It Works
          </button>
          <button
            data-testid="nav-join-waitlist-btn"
            onClick={() => goto("waitlist")}
            className="tile-shine bg-[#3D7A5A] text-[#F5F0E8] text-sm font-bold tracking-wide px-5 py-2.5 rounded-sm hover:bg-[#2E5C44] transition-colors"
          >
            Join Waitlist
          </button>
        </nav>

        {/* Mobile */}
        <div className="md:hidden flex items-center gap-3">
          <button
            data-testid="nav-join-waitlist-mobile-btn"
            onClick={() => goto("waitlist")}
            className="bg-[#3D7A5A] text-[#F5F0E8] text-xs font-bold tracking-wide px-3.5 py-2 rounded-sm"
          >
            Join Waitlist
          </button>
          <button
            data-testid="nav-mobile-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMobileOpen((v) => !v)}
            className="w-9 h-9 grid place-items-center border border-[#E5DFD3] rounded-sm"
          >
            <span className="relative block w-4 h-3">
              <span
                className={`absolute left-0 right-0 h-[2px] bg-[#1A1A1A] transition-transform ${
                  mobileOpen ? "top-1.5 rotate-45" : "top-0"
                }`}
              />
              <span
                className={`absolute left-0 right-0 top-1.5 h-[2px] bg-[#1A1A1A] transition-opacity ${
                  mobileOpen ? "opacity-0" : "opacity-100"
                }`}
              />
              <span
                className={`absolute left-0 right-0 h-[2px] bg-[#1A1A1A] transition-transform ${
                  mobileOpen ? "top-1.5 -rotate-45" : "top-3"
                }`}
              />
            </span>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-[#F5F0E8] border-t border-[#E5DFD3]"
        >
          <div className="px-5 py-4 flex flex-col gap-3 text-[#1A1A1A] text-sm">
            <button
              data-testid="nav-features-mobile-link"
              onClick={() => goto("features")}
              className="text-left py-2"
            >
              Features
            </button>
            <button
              data-testid="nav-how-mobile-link"
              onClick={() => goto("how")}
              className="text-left py-2"
            >
              How It Works
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
